import { render, staticRenderFns } from "./TheadEx.vue?vue&type=template&id=5d9fba52&scoped=true&"
import script from "./TheadEx.vue?vue&type=script&lang=js&"
export * from "./TheadEx.vue?vue&type=script&lang=js&"
import style0 from "./TheadEx.vue?vue&type=style&index=0&id=5d9fba52&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9fba52",
  null
  
)

export default component.exports